import { GET, POST } from '@/utils/http'

/** 获取活动列表 */
export const getActivities = () => GET('/shengbo/open/education/pbEducationActivity/all')

/** 获取活动详情 */
export const getActivityDetail = id => GET('/shengbo/open/education/pbEducationActivity/queryById', { id })

/** 提交活动报名 */
export const submitApply = ({
  eduId, sessionId, num, phone, detailList
}) => POST('/shengbo/open/education/pbEducationApply/apply', {
  eduId, sessionId, num, phone, detailList
})

/** 报名查询 */
export const querySignResultByPhone = ({ phone, activityId }) => GET('/shengbo/open/education/pbEducationApply/queryApplyInfo', { phone, activityId })

/** 在线课堂列表 */
export const getPbEducationOnlineClass = ({ pageNo = 1, pageSize = 5 }) => GET('/shengbo/open/education/pbEducationOnlineClass/list', { pageNo, pageSize })

/** 往期回顾列表 */
export const getPbEducationHistory = ({ pageNo = 1, pageSize = 5 }) => GET('/shengbo/open/education/pbEducationHistory/list', { pageNo, pageSize })

/** 往期回顾查询富文本 */
export const getPbEducationHistoryId = id => GET('/shengbo/open/education/pbEducationHistory/queryById', { id })

/** 在线课堂详情视频 */
export const getVideoId = id => GET('/shengbo/open/education/pbEducationOnlineClass/queryById', { id })

/** 活动取消 */
export const postActivities = applyId => POST(`/shengbo/open/education/pbEducationApply/cancelApply?applyId=${applyId}`)

/** 签到接口 */
export const postSign = applyId => POST(`/shengbo/open/education/pbEducationApply/sign?applyId=${applyId}`)
